import Contact from "../page/Contact";

const ContactSection = () => {
    return (
        <section
            id="contact"
            data-section
            data-title="Contact"
            aria-label="Contact"
            className="relative w-full min-h-screen"
        >
            <Contact />
        </section>
    );
};

export default ContactSection;
